
const lang = 'CN';//语言种类 简体CN 繁体 CNTW 
// const lang = 'CNTW';//语言种类 简体CN 繁体 CNTW 
const number = 85;//届数 每年修改
const httpType = window.location.protocol;
const imgUrl = `${httpType}//www.chinafair.org.cn`;//图片路径http://new.chinafair.org.cn
let [pdfUrl, mySelf] = [];
if (lang == 'CN') {
    pdfUrl = `${imgUrl}/CifitSystem/china`;//pdf路径 简体china
    mySelf = `${imgUrl}/CifitSystem/china/#/index`;//本网站 简体china 
} else if (lang == 'CNTW') {
    pdfUrl = `${imgUrl}/CifitSystem/chinatw`;//pdf路径 繁体chinatw
    mySelf = `${imgUrl}/CifitSystem/chinatw/#/index`;//本网站 繁体chinatw
}
let SelfServicelogin = '';//客商自助服务中心
let xmcrmLogin = '';//厦门会展客户关系管理系统
let ProjectFilling = ''; //项目填报
// const aboutUs = 'http://www.xmce.org/hzjdetail.asp?id=3714';//关于我们
const aboutUs = '#/about';

const otherimgurl = 'http://www.xmcrm.org'
const xicec = 'https://isp.xicec.com/';//在线展具租赁
const Venues = 'https://www.xicec.com';//展馆介绍
const iiforum = 'https://www.chinafair.org.cn/iiforum/#/';//国际投资论坛

// const cifitWeb =  'https://amy.ptnetwork001.com/OnlineCifit/cifitWeb/#/';//国际投资洽谈会  测试
// const cifitWebRoom = 'https://amy.ptnetwork001.com/OnlineCifit/cifitWeb/#/room?language='+lang

const cifitWeb = 'https://www.chinafair.org.cn/OnlineCifit/cifitWeb/index.html#/';//国际投资洽谈会  正式
const cifitWebRoom = 'https://www.chinafair.org.cn/OnlineCifit/cifitWeb/index.html#/room?language=' + lang

const wb = 'https://weibo.com/cifit?display=0&retcode=6102';//微博
const VolunteerReg = `http://www.xmcrm.org/SelfServiceCenter/Register/Test/Test.aspx?exhid=${number}`;//志愿者注册
let target = '';
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    SelfServicelogin = `https://www.xmcrm.org/self/index.html#/?ExhId=${number}`;

    xmcrmLogin = 'https://www.xmcrm.org/tqhht/index.html#/';//网上办公室
    // xmcrmLogin='https://amy.ptnetwork001.com/cifit/cifitWeb/#/login'

    // ProjectFilling = 'https://tq.digitalexpo.com/user/login';https://manage.touzicloud.com
    // ProjectFilling='https://manage.touzicloud.com';
    ProjectFilling = 'https://merchants.touzicloud.com/index';
    target = ''
} else {
    // SelfServicelogin = `https://www.xmcrm.org/SelfServiceCenter/login.aspx?exhid=${number}`;
    SelfServicelogin = `https://www.xmcrm.org/SelfServiceCenter/login.aspx?exhid=AI6FNH`;

    xmcrmLogin = 'https://www.xmcrm.org/login.aspx';//网上办公室
    // xmcrmLogin='https://amy.ptnetwork001.com/cifit/cifitWeb/#/login'

    // ProjectFilling = 'https://tq.digitalexpo.com/user/login';
    // ProjectFilling='https://manage.touzicloud.com';
    ProjectFilling = 'https://merchants.touzicloud.com/index';
    target = '_blank'
}
export default {
    lang,
    number,
    httpType,
    imgUrl,
    otherimgurl,
    SelfServicelogin,
    ProjectFilling,
    target,
    xmcrmLogin,
    aboutUs,
    mySelf,
    xicec,
    Venues,
    iiforum,
    pdfUrl,
    wb,
    VolunteerReg,
    cifitWeb,
    cifitWebRoom
}


// WEBPACK FOOTER //
// ./src/util/globalVar.js